<template>
  <!-- my profile screen, shows the data of the logged in user and possible edits -->

  <div
    class="modal fade"
    data-keyboard="false"
    data-backdrop="static"
    id="firstStepVideo"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="text-center text-join">Primeiros passos</h5>

          <button
            type="button"
            class="close"
            id="closeChangePasswordModal"
            data-dismiss="modal"
            aria-label="Close"
            @click="
              stop();
              $refs.videoPortal.currentTime = 0;
            "
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div id="player">
            <video
              ref="videoPortal"
              controls
              @play="play"
              @pause="stop"
            >
              <source
                src="/static/img/nova_versao_portal.mp4"
                type="video/mp4"
              />
            </video>
          </div>
          <div class="center-button">
            <button
              class="btn access"
              id="playVideo"
              :disabled="isPlaying"
              @click="play"
            >
              <em class="fa fa-play"></em>
              Play
            </button>
            <button
              style="margin-left: 5px"
              class="btn access"
              id="stopVideo"
              :disabled="!isPlaying"
              @click="stop"
            >
              <em class="fa fa-pause"></em> Pause
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "FirstStepVideo",
  data() {
    return {
      isPlaying: false,
    };
  },

  methods: {
    play() {
      this.$refs.videoPortal.play();
      this.isPlaying = true;
    },
    stop() {
      this.$refs.videoPortal.pause();
      this.isPlaying = false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.text-join {
  color: rgb(100, 95, 95);
  font-size: 20px;
  margin-left: 35%;
}

.text-align-center {
  color: rgb(100, 95, 95);
  font-size: 14px;
}

video {
  width: 100%;
  max-height: 100%;
}
.center-button {
  display: flex;
  justify-content: center;
}
.access {
  color: #fff;
  width: 20%;
  margin-top: 15px;
  border-radius: 6px;
  cursor: pointer;
  padding: 5px;
  font-size: 17px;
  text-decoration: none;
}

.access:disabled {
  cursor: no-drop;
}

@media only screen and (max-width: 900px) {
  .text-join {
    color: rgb(100, 95, 95);
    font-size: 20px;
    margin-left: 28%;
  }

  .text-align-center {
    margin-top: 5px;
    color: rgb(100, 95, 95);
    font-size: 14px;
  }

  .modal {
    padding: 0px !important;
  }
  .access {
    color: #fff;
    width: 30%;
    margin-top: 15px;
    border-radius: 6px;
    cursor: pointer;
    padding: 5px;
    font-size: 17px;
    text-decoration: none;
  }
}
@media only screen and (min-width: 960px) {
  /* styles for browsers larger than 960px; */
  .modal-dialog {
    margin-top: 4%;
  }
}
@media only screen and (min-width: 1440px) {
  /* styles for browsers larger than 1440px; */
  .modal-dialog {
    margin-top: 7%;
  }
}
@media only screen and (max-device-width: 480px) {
  /* styles for mobile browsers smaller than 480px; (iPhone) */
  .modal-dialog {
    margin-top: 20%;
  }
}
@media only screen and (device-width: 768px) {
  /* default iPad screens */
  .modal-dialog {
    margin-top: 30%;
  }
}

@media only screen and (min-width: 2000px) {
  .modal-dialog {
    margin-top: 12%;
  }
  /* for sumo sized (mac) screens */
}
/* different techniques for iPad screening */
@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: portrait) {
  /* For portrait layouts only */
  .modal-dialog {
    margin-top: 35%;
  }
}

@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: landscape) {
  /* For landscape layouts only */
  .modal-dialog {
    margin-top: 35%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/firstStep/FirstStepVideo.vue